import client, { CLIENT_GET_FILE, CLIENT_POST_FILE } from 'api/client';

import { createURLParams } from 'utils/urls';

export const getFirmById = async firmId => {
  const { data } = await client.get(`firms/${firmId}/`);
  return data;
};

export const getFirmFeeScheduleAdjustmentDocument = firmId =>
  CLIENT_GET_FILE.get(`firms/${firmId}/get-fee-schedule-adjustment-document/`);

export const uploadFirmFeeScheduleAdjustmentDocument = async (firmId, document) => {
  const formData = new FormData();
  formData.append('fee_schedule_adjustment_document', document);
  formData.append('filename', document.name);

  const { data } = await CLIENT_POST_FILE.patch(
    `firms/${firmId}/update-fee-schedule-adjustment-document/`,
    formData,
  );
  return data;
};

export const populateFirmStore = firmId => client.get(`firms/${firmId}/?for_store=True`);

export const getFirms = async ({
  locationCode,
  nameOrPhone,
  attorneyCode,
  city,
  county,
  state,
  zip,
  languages,
  services,
  status,
  distance,
}) => {
  const params = createURLParams({
    location_code: locationCode,
    name_or_phone: nameOrPhone,
    attorney_code: attorneyCode,
    firm_status: status,
    city,
    county,
    state,
    zip,
    languages,
    services,
    distance,
  });
  const { data } = await client.get('firms/', { params });
  return data;
};

export const getMasterFileFirms = async ({
  locationCode,
  nameOrPhone,
  attorneyCode,
  city,
  county,
  state,
  zip,
  languages,
  services,
  status,
  distance,
}) => {
  const params = createURLParams({
    location_code: locationCode,
    name_or_phone: nameOrPhone,
    attorney_code: attorneyCode,
    firm_status: status,
    city,
    county,
    state,
    zip,
    languages,
    services,
    distance,
  });
  const { data } = await client.get('firms/master-file-row/', { params });
  return data;
};

export const findAndUpdateFirm = async payload => {
  const url = `firms/${payload.id}/`;
  const document = payload.feeScheduleAdjustmentDocument;
  const firmPayload = { ...payload };

  delete firmPayload.feeScheduleAdjustmentDocument;
  delete firmPayload.feeScheduleAdjustmentDocumentFilename;

  if (document) {
    await uploadFirmFeeScheduleAdjustmentDocument(payload.id, document);
  }

  const { data } = await client.patch(url, firmPayload);
  return data;
};

export const addFirm = payload => client.post('firms/', payload);

export const validateFirmData = payload => client.post('firms/validate-firm/', payload);

export const hasPaymentInfo = async pk => {
  const { data } = await client.get(`firms/${pk}/has-payment-info/`);
  return data;
};

export const hasSubmittedMalpractice = firm =>
  client.get('firms/has-submitted-malpractice/', { firm });

export const createMalpracticeDocument = payload =>
  CLIENT_POST_FILE.post('firms/malpractice-documents/', payload);

export const getMalpractice = payload => {
  const searchParams = new URLSearchParams(payload);
  return client.get(`firms/malpractice-documents/?${searchParams}`);
};

export const getMalpracticeDocument = id =>
  CLIENT_GET_FILE.get(`firms/malpractice-documents/${id}/`);

export const getFirmOptions = async () => {
  const { data } = await client.get('firms/options/');
  return data;
};

export const getLocationCodes = async () => {
  const { data } = await client.get('firms/location-codes/');
  return data;
};
